import ContentWrapper from "@/components/wrappers/ContentWrapper";
import { useFilterSearchParams } from "@/utils/hooksUtils";
import { COMMON_AGENT_FILTER_SEARCH_PARAMS } from "../../../agent/api";
import { DEFAULT_BAIL_ACCOUNTS_REPORT_QUERY_PARAMS } from "../api";
import { BailAccountsReportFilterView } from "../components/views/BailAccountsReportFilterView";
import { BailAccountsReportTableView } from "../components/views/BailAccountsReportTableView";
import { BailAccountsReportFilterPageRequest } from "../types";

export const BailAccountsReportContainer = () => {
  const searchParams = useFilterSearchParams<BailAccountsReportFilterPageRequest>({
    params: ["balanceAsOfDate", "categories", ...COMMON_AGENT_FILTER_SEARCH_PARAMS, "includeUnprocessed"],
    defaultQueryParamsObject: DEFAULT_BAIL_ACCOUNTS_REPORT_QUERY_PARAMS,
  });

  return (
    <ContentWrapper>
      <BailAccountsReportFilterView searchParams={searchParams} />

      <BailAccountsReportTableView searchParams={searchParams} />
    </ContentWrapper>
  );
};
